// Fontawesome 5
import './shared/font-awesome';

// Style
import '../scss/app.scss';

// App Config
import AppConfig from './app.config';

// ImportModuleJS
import AuthenticationModule from "./components/Authentication/Authentication.module";


import AppRun from './app.run';


/**
 * @api {get} /user/:id Request User information
 * @apiName GetUser
 * @apiGroup User
 * @apiDeprecated use now (#Group:Name).  
 * @apiDescription This is the Description.
 * @apiParam {Number} id Users unique ID.
 *
 * @apiSuccess {String} firstname Firstname of the User.
 * @apiSuccess {String} lastname  Lastname of the User.
 */


const ngModule = angular
    .module("app", [

        /* Shared modules */
        //"app.core",
        "ui.router",
        "oc.lazyLoad",
        "ngResource",
        "ngMaterial",
        "ngMessages",
        "ngAria",
        "ngAnimate",
        "ngCookies",
        "ngOidc",
        /* Feature areas*/
        "AuthenticationModule",
    ]);


ngModule.config(AppConfig);
ngModule.run(AppRun);


// Auth
require('./shared/auth/authHttpResponseInterceptor')(ngModule);

export {
    ngModule
};